/* Euronics homepage v2 - shell behaviour. Homepage only, no dependencies.
   Everything here is opt-in through data-eur-* hooks and no-ops when they are absent.
   It deliberately ignores the existing product carousels (data-fc-carousel /
   data-jfy-track), which keep their own scripts, so nothing is driven twice. */
(function () {
  'use strict';

  var RAIL = '[data-eur-rail]';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function isForeignCarousel(track) {
    return track.hasAttribute('data-fc-carousel') || track.hasAttribute('data-jfy-track');
  }

  function step(track) {
    var card = track.firstElementChild;
    var width = card ? card.getBoundingClientRect().width : 0;
    if (!width) return Math.max(track.clientWidth * 0.8, 1);
    var styles = window.getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return width + gap;
  }

  function scrollBy(track, amount) {
    var behavior = reduce.matches ? 'auto' : 'smooth';
    if (typeof track.scrollBy === 'function') {
      track.scrollBy({ left: amount, behavior: behavior });
    } else {
      track.scrollLeft += amount;
    }
  }

  function sync(rail, track, prev, next) {
    var overflow = track.scrollWidth - track.clientWidth;
    var atStart = track.scrollLeft <= 1;
    var atEnd = track.scrollLeft >= overflow - 1;
    rail.classList.toggle('is-overflowing', overflow > 1);
    rail.classList.toggle('is-start', atStart);
    rail.classList.toggle('is-end', atEnd);
    if (prev) prev.disabled = atStart;
    if (next) next.disabled = atEnd;
  }

  function initRail(rail) {
    if (rail.dataset.eurRailReady === 'true') return;
    var track = rail.querySelector('[data-eur-rail-track]');
    if (!track || isForeignCarousel(track)) return;
    rail.dataset.eurRailReady = 'true';

    var prev = rail.querySelector('[data-eur-rail-prev]');
    var next = rail.querySelector('[data-eur-rail-next]');
    var update = function () {
      sync(rail, track, prev, next);
    };

    if (prev) {
      prev.addEventListener('click', function () {
        scrollBy(track, -step(track));
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        scrollBy(track, step(track));
      });
    }

    track.addEventListener('keydown', function (event) {
      var key = event.key;
      if (key === 'ArrowRight') {
        scrollBy(track, step(track));
      } else if (key === 'ArrowLeft') {
        scrollBy(track, -step(track));
      } else if (key === 'Home') {
        scrollBy(track, -track.scrollLeft);
      } else if (key === 'End') {
        scrollBy(track, track.scrollWidth);
      } else {
        return;
      }
      event.preventDefault();
    });

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(update).observe(track);
    }
    update();
  }

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var rails = scope.querySelectorAll(RAIL);
    for (var i = 0; i < rails.length; i++) initRail(rails[i]);
  }

  function ready() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }

  /* Theme editor: bring a freshly selected block into view inside its own rail. */
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target;
    if (!block || !block.closest || !block.closest('.eur-home-v2')) return;
    block.scrollIntoView({
      behavior: reduce.matches ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  });
}());
